import type { ReactNode } from 'react';

export const symbol_lips: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M482-464q105 0 202-27t153-48L660-708q-5-4-9.5-6t-10.5-2q-4 0-8 1t-8 3l-127 78q-8 5-15.5 5t-15.5-5l-127-78q-4-2-8-3t-8-1q-6 0-11 2t-10 6L126-539q56 22 153 48.5T482-464Zm-9 217h16q126 0 208-67.5T844-488q-65 23-161.5 47T481-417q-105 0-202-25t-162-47q65 108 147 175t209 67Zm16 47h-16q-140 0-254-82T51-493q-6-15-2.5-31T64-551l197-188q13-12 29-18t33-6q13 0 26 3t24 11l108 71 108-70q11-7 23.5-11t25.5-4q17 0 32.5 6t27.5 17l194 173q12 11 16.5 27t-1.5 32q-51 140-164.5 224T489-200Z"
		/>
	</svg>
);
